/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
import React from 'react';
import './VMNManagement.css';
import CsvDownloader from 'react-csv-downloader';
import SearchVMNManagement from './SearchVMNManagement';

const ReleaseVMNs = () => {
  const popup_props = {
    name: 'Upload CSV',
    title: "Choose VMN's CSV File",
    url: 'admin/console/release-vmns',
    method: 'releasevmns',
  };
  return (
    <div style={{ textAlign: 'center', fontWeight: 'bolder' }}>
      <form className="form-horizontal">
        <div className="container">
          <div className="label">
            Release VMNs
          </div>
          <div className="inputs-fl-1">
            { /* eslint-disable-next-line react/jsx-props-no-spreading */ }
            <SearchVMNManagement {...popup_props} />
          </div>
          <div className="inputs-fl-1">
            <CsvDownloader
              style={{
                cursor: 'pointer',
                color: '#337ab7',
                textDecoration: 'none',
              }}
              filename="sample file"
              datas={[
                {
                  917899734982: '919872653288',
                },
              ]}
            >
              <a style={{
                cursor: 'pointer',
                color: '#337ab7',
                textDecoration: 'none',
              }}
              >
                Sample file
              </a>
            </CsvDownloader>
          </div>
        </div>
      </form>
    </div>
  );
};
export default ReleaseVMNs;
